import { useMutation, useQueryClient } from "@tanstack/react-query";
import { trainerFilesApi, TrainerFileStatusApi } from "api/trainers/trainerFilesApi";
import { QUERIES_KEYS } from "queries";

export const useSetTrainerFileStatus = (trainerId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ fileId, status }: { fileId: number; status: TrainerFileStatusApi }) =>
      trainerFilesApi.setStatus(trainerId, fileId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.TRAINER_FILES(trainerId) });
    },
  });
};
